import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
    AllProcessData: [],
    AllCollaborateData: [], 
    AllKivData: [],         // Added to store KIV list if needed
    processCount: 0,
    kivCount: 0,           
    collaborateCount: 0,    
    isFetching: false,
    isAllProcessSuccess: false,
    isAllCollaborateSuccess: false,
    isAllKivSuccess: false, // Added for tracking KIV status
    isError: false,
    errorMessage: '',
};

// --- Process Logic ---
export const getAllProcess = createAsyncThunk(
    'chd/allProcess',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/chd/allProcess?limit=10&page=${udata}`,
                method: 'get',
                headers: { "Authorization": `Bearer ${tokenStr}` }
            })
            
            let data = response.data;
            if (response.status === 200 || data.code === 200) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || { message: 'Internal error' });
        }
    }
);

// --- KIV Logic (loadKiv) ---
export const getAllKiv = createAsyncThunk(
    'chd/loadKiv',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/chd/loadKiv?limit=10&page=${udata}`,
                method: 'get',
                headers: { "Authorization": `Bearer ${tokenStr}` }
            })
            
            let data = response.data;
            if (response.status === 200 || data.code === 200) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || { message: 'Internal error' });
        }
    }
);

export const addKiv = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.post('/api/chd/addKiv', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });
    return response.data;
};

// --- Collaboration Logic ---
export const getAllCollaborateDoc = createAsyncThunk(
    'chd/allCollaboratedDoc',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/chd/collaboratedDoc?limit=10${udata ? udata : ''}`,
                method: 'get',
                headers: { "Authorization": `Bearer ${tokenStr}` }
            })

            let data = response.data;
            if (response.status === 200 || data.code === 200) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || { message: 'Internal error' });
        }
    }
);

// --- Search & Delete ---
export const SearchAllProcess = (sdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let response = await axios({
            url: `/api/chd/allProcess?${sdata}`,
            method: 'get',
            headers: { "Authorization": `Bearer ${tokenStr}` }
        });
        return response.data;
    } catch (err) {
        console.error(err);
    }
};

export const DeleteProcessAsyn = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let response = await axios({
        url: `/api/chd/process/${bdata}`,
        method: 'delete',
        headers: { "Authorization": `Bearer ${tokenStr}` }
    })
    return response.data;
};

// --- Slice Definition ---
export const ChdAllProcessSlice = createSlice({
    name: 'ChdAllProcess',
    initialState,
    reducers: {
        clearStateAllProcess: (state) => {
            state.AllProcessData = [];
            state.AllCollaborateData = [];
            state.AllKivData = [];
            state.isAllProcessSuccess = false;
            state.isAllCollaborateSuccess = false;
            state.isAllKivSuccess = false;
            state.processCount = 0;
            state.collaborateCount = 0;
            state.kivCount = 0;
            state.isError = false;
            state.errorMessage = '';
        },
    },
    extraReducers: {
        // Handle All Process
        [getAllProcess.fulfilled]: (state, { payload }) => {
            state.AllProcessData = payload.data;
            state.processCount = payload.data.count; 
            state.isFetching = false;
            state.isAllProcessSuccess = true;
        },
        [getAllProcess.pending]: (state) => {
            state.isFetching = true;
        },
        [getAllProcess.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload?.message || 'Internal error';
        },

        // Handle loadKiv
        [getAllKiv.fulfilled]: (state, { payload }) => {
            state.AllKivData = payload.data;
            state.kivCount = payload.data.count; // This sets the count for your dashboard card
            state.isFetching = false;
            state.isAllKivSuccess = true;
        },
        [getAllKiv.pending]: (state) => {
            state.isFetching = true;
        },
        [getAllKiv.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload?.message || 'Internal error';
        },

        // Handle Collaboration Data
        [getAllCollaborateDoc.fulfilled]: (state, { payload }) => {
            state.AllCollaborateData = payload.data;
            state.collaborateCount = payload.data.count;
            state.isFetching = false;
            state.isAllCollaborateSuccess = true;
        },
        [getAllCollaborateDoc.pending]: (state) => {
            state.isFetching = true;
        },
        [getAllCollaborateDoc.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload?.message || 'Internal error';
        }
    },
});

export const { clearStateAllProcess } = ChdAllProcessSlice.actions;

export function clearState() {
    return async (dispatch) => {
        dispatch(clearStateAllProcess());
    }
}

export const chdAllProcessSelector = (state) => state.ChdAllProcess;

export default ChdAllProcessSlice.reducer;